import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { Configuration } from 'src/app/models/configurations/configuration';
import { ConfigurationApplicationStatus, ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Constants } from 'src/app/models/constants';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-automatic-logout-popup',
    templateUrl: './automatic-logout-popup.component.html',
    styleUrls: ['./automatic-logout-popup.component.scss'],
    standalone: false
})
export class AutomaticLogoutPopupComponent implements OnInit {
  title: string = translate('DIALOG.CONFIRMATION');
  messageInactive: string;
  messageSecurity: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  setTimeOutId: any;
  resetButton = true;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialog: MatDialog, private authService: AuthService) {
  }
  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.messageInactive = this.data.messageInactive;
    this.messageSecurity = this.data.messageSecurity;
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
    this.setTimeOut();
  }

  logOut(): void {
    this.resetButton = false;
    clearTimeout(this.setTimeOutId);
    this.dialog.closeAll();
    this.authService.logout();
  }

  reset(): void {
    clearTimeout(this.setTimeOutId);
  }

  setTimeOut(): void {
      this.setTimeOutId = setTimeout(() => {
        this.dialog.closeAll();
        this.authService.logout();
      }, 30000);
  }
}